import React from "react";
import styles from "./adCard.scss"

export const AboveTitle = ({ ad }) => {
  return (
    <div className={styles.aboveTitle}>
      {ad.postedTime}
      {ad.location && (
        <span>
          {" "}<span>|</span>{" "}
          {ad.location}
        </span>
      )}
      {" "}<span>|</span>{" "}
      Kod {ad.code}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AboveTitle.tsx